// These vars should be in sync with css values, since they are used to
// estimate row height and style boxes via style prop.

export const CELL_PADDING_X = 5;
export const HEAD_CELL_PADDING_TOP = 14;
export const HEAD_CELL_PADDING_BOTTOM = 14;
export const ROW_CELL_PADDING_TOP = 10;
export const ROW_CELL_PADDING_BOTTOM = 10;
